import { FC } from 'react'
import { cva } from 'class-variance-authority'

import { loaderV2Type } from './loader.types'

const loaderStyles = cva('m-0 flex items-center p-0 animate-spin', {
  variants: {
    size: {
      small: 'w-4',
      medium: 'w-8',
      large: 'w-12',
    },
  },
})

// Global Loader Component
// It accepts a size prop with three size options "small" | "medium" | "large"
// Color of the loader is static (Theme color)

export const Loader: FC<loaderV2Type> = ({ size = 'medium', color = 'var(--grey-95, #0C0D0D)' }) => {
  return (
    <div>
      <svg 
        focusable="false"
        aria-hidden="true"
        fill="currentColor"
        data-icon="loading"
        viewBox="0 0 1024 1024"
        style={{ fill: `${color}` }}
        className={`${loaderStyles({ size })}`}
      >
        <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"/>
      </svg>
      <span className="sr-only">Loading...</span>       
    </div>
  )
}